var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.547,
    height: 22.626,
    viewBox: "0 0 29.547 22.626",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.825,14.854,37.41,12.371a.519.519,0,0,0-.384-.165h0a.5.5,0,0,0-.384.165L19.9,29.234,13.81,23.142a.531.531,0,0,0-.768,0L10.6,25.584a.547.547,0,0,0,0,.782l7.684,7.684a2.43,2.43,0,0,0,1.605.782,2.546,2.546,0,0,0,1.592-.755h.014L39.839,15.637A.587.587,0,0,0,39.825,14.854Z",
    transform: "translate(-10.434 -12.206)",
    fill: "#17a93e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmark);
export default __webpack_public_path__ + "static/media/icon-checkmark.6478d415420083dc854ff5a635aa6e22.svg";
export { ForwardRef as ReactComponent };